<script>
export default {
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {

    }
  }
}
</script>
<template>
  <v-dialog :value="show" max-width="500" persistent>
    <v-card>
      <DialogBaseColoredTitle color="primary">{{
          $t('component.testletter.testletterCompleted.header')}}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText class="text-center">
        <p>{{ $t('component.testletter.testletterCompleted.p1') }}</p>
        <p>{{ $t('component.testletter.testletterCompletedp2') }}</p>
        <v-divider />
        <h4 class="pa-4">{{ $t('component.testletter.testletterCompletedp3') }}</h4>
        <p>
          <v-btn
            id="routeToRegister"
            :to="{
              name: 'register'
            }"
            elevation="5"
            class="tam-yellow">
            {{ $t('button.send.letters.easily') }}</v-btn></p>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions
      ><v-btn color="primary" @click="$emit('onClose')">{{
          $t('button.ok')}}</v-btn></DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
